/**
 * 跨子系統共用的 profile cache（localStorage）
 * 任一子系統查過 profile 後，其他子系統直接從 cache 讀，不重複查 DB
 *
 * 策略：
 * - cache 有效期 5 分鐘（避免角色/名稱變更後一直讀到舊資料）
 * - 有 cache 時先用 cache 顯示（避免白畫面），再背景刷新
 * - logout 時清 cache
 */

const CACHE_KEY = 'sonice-user-profile'
const CACHE_TTL = 5 * 60 * 1000 // 5 分鐘

export function getCachedProfile() {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const { data, timestamp } = JSON.parse(raw)
    if (Date.now() - timestamp > CACHE_TTL) {
      localStorage.removeItem(CACHE_KEY)
      return null
    }
    return data
  } catch {
    return null
  }
}

export function setCachedProfile(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data,
      timestamp: Date.now(),
    }))
  } catch {
    // localStorage 滿或被禁用，忽略
  }
}

export function clearCachedProfile() {
  localStorage.removeItem(CACHE_KEY)
}
